export default __webpack_public_path__ + "static/media/hero.b788a397.png";